import { useI18n } from '@whizz/react-i18n';
import React from 'react';

const format = (value: string): string => {
  const rawValue = value.replace(/[-\s]/g, '').substring(0, 9);
  return rawValue.match(/.{1,3}/g)?.join('-').toUpperCase() || '';
};

const getClassLoginLink = (code: string | null | undefined): string => {
  const { locale } = useI18n();
  return `https://${process.env.REACT_APP_HOSTNAME_LOGIN}/class-login/${code}?locale=${locale?.id}`;
};

const AccessCode = ({ code }: { code: string | null }): JSX.Element => {

  const link = getClassLoginLink(code);

  return (
    <div className={'font-mono font-normal tracking-widest whitespace-nowrap'} data-cy={'picture-login-code'}>
      { code ? (
        <a href={link} target={'_blank'} rel={'noreferrer'} className={'font-bold text-blue-800 underline hover:no-underline'}>
          {format(code)}
        </a>)
        : 'N/A' }
    </div>
  );
};

const AccessCodeWrapper = ({ code, children }: { code: string | null | undefined, children: React.ReactNode }): JSX.Element => {
  const link = getClassLoginLink(code);
  return (
    <>
      {code ? <a href={link} target={'_blank'} rel={'noreferrer'}>{children}</a> : children}
    </>
  );
};

export { AccessCodeWrapper };
export default AccessCode;
